import { useContext } from 'react';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { SiteContext } from '../../../public/site/SiteContext.js';
import { EoeLoginPage } from '../../EoeLoginPage/EoeLoginPage';
import { LanguageSelector } from '../LanguageSelector.js';

export interface AuxiliaryEsimOrderLoginProps {
  startElisaIdV2Login: (locale: string) => void;
}

export const AuxiliaryEsimOrderLogin = ({ startElisaIdV2Login }: AuxiliaryEsimOrderLoginProps) => {
  const { siteLanguage, saveUserPreferredLocale } = useContext(SiteContext);

  return (
    <>
      <LanguageSelector onChangeLocale={saveUserPreferredLocale} selectedLocale={siteLanguage} />
      <div id="elisaid-login-form-parent" className={`${dsClass.BACKGROUND_COLOR_WHITE} of-login-form`}>
        <EoeLoginPage
          initiateLogin={() => startElisaIdV2Login(siteLanguage.substring(0, 2))}
          isAuxiliarySimLogin={true}
        />
      </div>
    </>
  );
};
